import { render, staticRenderFns } from "./BotConfiguration.vue?vue&type=template&id=8b4ccf60&scoped=true&"
import script from "./BotConfiguration.vue?vue&type=script&lang=js&"
export * from "./BotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BotConfiguration.vue?vue&type=style&index=0&id=8b4ccf60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ccf60",
  null
  
)

export default component.exports